import { memo } from "react";
import { FaStore, FaCity } from "react-icons/fa";
import { AppLink } from "../../shared";
import { getFirmTypeStyle } from "../../../utils/firmTypeStyles";

/**
 * Molekül: uyarı kaydının doğrudan üst firması (#245) — "Bayi: …" ya da
 * "Ana firma: …". Renk firma tipi tek kaynağından (#215). Zincir daha uzunsa
 * (ör. alt bayi → üst bayi) grubun tepesi ipucunda yazar. Üstü yoksa çizilmez.
 * Üzerine gelince altı çizilir, tıklanınca üst firmaya gider (#367).
 */
function ParentFirmBadge({ group, onNavigate, className = "" }) {
  const parent = group?.parent;
  if (!parent?.firmName) return null;
  const isDealer = parent.firmType === "dealer";
  const style = getFirmTypeStyle(parent.firmType || "customer");
  const Icon = isDealer ? FaStore : FaCity;
  const prefix = isDealer ? "Bayi" : "Ana firma";
  const root = group?.root;
  const title =
    root && root._id !== parent._id ? `${prefix}: ${parent.firmName} · Grup: ${root.firmName}` : `${prefix}: ${parent.firmName}`;
  const badgeClass = `inline-flex w-fit max-w-full items-center gap-1 rounded-md border px-1.5 py-0.5 text-[10px] font-SemiBold ${style.badge} ${className}`;
  const content = (
    <>
      <Icon className="h-2.5 w-2.5 shrink-0" />
      <span className="truncate">
        {prefix}: {parent.firmName}
      </span>
    </>
  );
  if (!parent._id) {
    return (
      <span title={title} className={badgeClass}>
        {content}
      </span>
    );
  }
  return (
    <AppLink
      to={`/Anasayfa/Firma/${parent._id}`}
      state={{ fromPage: "Anasayfa/Dashboard" }}
      onClick={onNavigate}
      title={`${title} — firmaya git`}
      className={`${badgeClass} underline-offset-2 transition hover:underline hover:brightness-95`}
    >
      {content}
    </AppLink>
  );
}

export default memo(ParentFirmBadge);
